// Bileli · modules/orgs/model — the CAPTURED org-invite token (#org-invite/<token> deep link), waiting
// for the signed-in redemption overlay (OrgInviteGate). Session-memory only, deliberately NOT persisted:
// the raw token is a bearer credential for a role grant (never localStorage), and the pre-auth capture
// works without persistence — util/routing snapshots location.hash at MODULE LOAD, before Telegram's
// auth screens rewrite the hash, so the token survives the whole same-tab sign-in flow. (A hard reload
// mid-sign-in drops it — the invitee just clicks their link again.)

import { createStore } from '../../../shared/lib/zustandTeact';

export const pendingInviteStore = createStore<{ token?: string }>(() => ({ token: undefined }));

export function setPendingInviteToken(token: string): void {
  pendingInviteStore.setState({ token }, true);
}

export function clearPendingInvite(): void {
  pendingInviteStore.setState({ token: undefined }, true);
}
